import Vue from 'vue';
import {
    MainVueOpts
} from '../../main-vue';
import Vuelidate from 'vuelidate';
import VueResource from 'vue-resource';

const {
    required,
} = require('vuelidate/lib/validators');

import {
    noForeignCharacters,
    goToFirstError,
    ApiUrls,
    SessionKeys,
    setItemSessionStorage,
    getItemSessionStorage,
    deleteSessionStore,
    scrollToBlock,
    isUserLoggedIn,
    RedirectsUrls,
    allowOnlyNumbers,
    allowOnlyLetters
} from '../../helper-functions';

import Spinner from '../../components/components.spinner.vue';
import Snackbar from "../../components/components.snack-bar.vue";
import Modal from '../../components/components.model.vue';
import InlineAds from '../../components/components.inline-ads.vue';
import DatePicker from '../../components/components.date-picker.vue';
import ButtonSvg from "../../components/components.button-svg.vue";

import {
    babyNamesMixin
} from '../../mixins/mixin.baby-names';

Vue.use(Vuelidate);
Vue.use(VueResource);

const Babyform = {
  religion: "",
  gender: "",
  startsWith: "",
  maxChars: null,
  rows: 10,
  page: 1,
  url: window.immiObj.action
};

Vue.component('baby-names', {
    mixins: [babyNamesMixin],
    components: {
        Spinner,        
        Snackbar,
        Modal,
        InlineAds,
        'date-picker': DatePicker,
        ButtonSvg
    },
    data () {
        return {            
            isFormSubmitted: false,
            isLoading: false,
            errors: [],
            pregnancyResult: {},
            dateRangePicker: {
                dateFormat: 'MM-DD-YYYY',
                singleDatePicker: true,
                autoApply: true,
                defaultRange: '',
            },
            targetedAds: window.immiObj.targetedAds,
            snackbarMessage: '',
            snackbarType: '',
            favoritesList: window.immiObj.favoritesList || []
        }
    },
    mounted () {
        if (isUserLoggedIn.isLoggedIn) {
            const isAddFav = getItemSessionStorage(SessionKeys.babyName.addFavorites);
            if (isAddFav) {                
                deleteSessionStore(SessionKeys.babyName.addFavorites);
                this.snackbarType = "success";
                this.snackbarMessage = "Please click favorite button next to the name to mark it as your favorite.";
                this.$refs.snackbar.open();
            }
        }
    },
    validations () {
        let validations = {
            form: {
                
            }
        };

        return validations;
    },
    methods: {
        reset () {
            this.$v.form.$reset();
            this.form = { ...Babyform };
        },
        addFavorites(id, name) {
            if (isUserLoggedIn.isLoggedIn) {
                this.$http.post(ApiUrls.babyNames.addFavorites, {
                    id: id
                }).then(res => {
                    const responseBody = res.body;
                    if (responseBody.message == "success") {
                        this.favoritesList.push(id);
                        this.snackbarType = 'success';
                        this.snackbarMessage = `${name} is added as favorite.`;
                        this.$refs.snackbar.open();
                    } else {
                        this.snackbarType = 'error';
                        this.snackbarMessage = responseBody.error && Array.isArray(responseBody.error) ? responseBody.error[0] : 'Something went wrong, please try again.';
                        this.$refs.snackbar.open();
                    }
                }, error => {
                    const responseBody = error.body;
                    this.snackbarType = 'error';
                    this.snackbarMessage = responseBody.error && Array.isArray(responseBody.error) ? responseBody.error[0] : 'Something went wrong, please try again.';
                    this.$refs.snackbar.open();
                })
            } else {
                setItemSessionStorage(SessionKeys.babyName.addFavorites, true);
                window.location.href = RedirectsUrls.login;
            }
        },
        allowOnlyNumbers: allowOnlyNumbers,
        allowOnlyLetters: allowOnlyLetters
    }
})

Vue.component('browse-all', {
    mixins: [babyNamesMixin],
    components: {
        InlineAds
    },
    data () {
        return {
            targetedAds: window.immiObj.targetedAds
        }
    },
    created () {

    },
    methods: {
        openLandingPage (gender, religion) {      
            this.form.gender = gender == 1 ? 'B' : 'G';
            this.form.religion = religion == 'hindu' ? 'h' : 'm';
            Vue.nextTick(() => $("#searchForm").submit());
        }
    }
})